export const EVENT_OPTIONS = [
  "ui.filter_by",
  "edit_dealer",
  "set_staff_data",
  "edit_staff",
  "add_staff",
  "delete_staff",
  "add_dealer_to_user",
  "delete_dealer_from_user",
  "edit_gr_version",
  "add_gr_version",
  "edit_gr_row",
  "add_gr_row",
  "edit_indicator",
  "add_indicator",
  "delete_indicator",
  "restore_indicator",
  "edit_q_version",
  "add_q_version",
  "edit_q_row",
  "add_q_row",
  "delete_user",
  "restore_user",
  "edit_user",
  "upload_indicator_values",
  "upload_dealer_to_user_csv",
  "upload_dealer_csv",
  "delete_q_version",
  "delete_gr_version",
  "delete_q_row",
  "delete_gr_row",
  "delete_file",
  "edit_file",
  "upload_file_to_catalog",
  "add_employee",
  "edit_employee",
  "edit_employee_positions",
  "add_employee_positions",
  "create_dealer",
  "create_announcement",
  "change_zd_values",
  "add_zd_definition",
  "change_zd_definition",
  "delete_zd_definition",
  "blind_change_zd_definition",
  "create_violation",
  "delete_violation",
  "un_delete_violation",
  "change_accounting_period",
  "add_accounting_period",
  "edit_education_level",
  "create_position_direction",
  "edit_position_direction",
  "delete_position_direction",
  "edit_education_course",
  "create_education_course",
  "delete_education_course",
  "create_education_level",
  "delete_education_level",
  "edit_education_group",
  "create_education_group",
  "delete_education_group",
  "create_education_catalog",
  "delete_education_catalog",
  "create_education_program",
  "delete_education_program",
  "edit_staff_education_group_all",

  // documents log events
  "create_document",
  "modify_document",
  "create_section",
  "modify_section",
  "delete_section",

  // camera log events
  "create_camera",
  "modify_camera",
  "delete_camera",
  "create_camera_check",
  "modify_camera_check",
  "create_camera_zone",
  "modify_camera_zone",
  "delete_camera_zone",

  // indicator reports log events
  "add_indicator_group",
  "edit_indicator_group",
  "delete_indicator_group",
  "restore_indicator_group",
  "add_indicators_to_group",
  "delete_indicators_from_group",
  "add_indicator_report",
  "edit_indicator_report",
  "delete_indicator_report",
  "restore_indicator_report",
  "add_indicators_to_report",
  "delete_indicators_from_report",
];
